import { render, staticRenderFns } from "./PageSettings.vue?vue&type=template&id=ad4587e8"
import script from "./PageSettings.vue?vue&type=script&lang=js"
export * from "./PageSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad4587e8')) {
      api.createRecord('ad4587e8', component.options)
    } else {
      api.reload('ad4587e8', component.options)
    }
    module.hot.accept("./PageSettings.vue?vue&type=template&id=ad4587e8", function () {
      api.rerender('ad4587e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageSettings.vue"
export default component.exports